document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-writer-forgot-form') || !window.WP) return;

    e.preventDefault();
    var emailEl = form.querySelector('input[name="email"]');
    var crsfEl  = form.querySelector('input[name="crsf"]');
    var errEl   = form.querySelector('.old-form-error');
    var msgBox  = form.querySelector('.js-writer-forgot-message');
    var submit  = form.querySelector('button[type="submit"]');
    if (!emailEl || !msgBox || !submit) return;

    msgBox.textContent = '';
    msgBox.className = 'js-writer-forgot-message';
    if (errEl) {
        errEl.textContent = '';
        var errGroup = errEl.closest('.old-form-group');
        if (errGroup) { errGroup.classList.remove('has-error'); }
    }

    var email = (emailEl.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errEl) {
            errEl.textContent = WP.L.FORGOT_INVALID_EMAIL;
            var group = errEl.closest('.old-form-group');
            if (group) { group.classList.add('has-error'); }
        } else {
            msgBox.textContent = WP.L.FORGOT_INVALID_EMAIL;
            msgBox.classList.add('is-error');
        }
        return;
    }

    submit.disabled = true;

    var fd = new FormData();
    fd.append('email', email);
    if (crsfEl) { fd.append('crsf', crsfEl.value); }

    fetch(WP.BASE + '/ajax_newpassword', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
            submit.disabled = false;
            var data = null;
            try { data = JSON.parse(txt); } catch (err) { data = null; }

            if (data && data.crsf && crsfEl) { crsfEl.value = data.crsf; }

            if (!data || data.error) {
                msgBox.textContent = WP.L.ERR_NETWORK;
                msgBox.classList.add('is-error');
                return;
            }

            msgBox.textContent = WP.L.FORGOT_OK;
            msgBox.classList.add('is-success');
            emailEl.value = '';
            setTimeout(function () { WP.closeActiveModals(); }, 2000);
        })
        .catch(function () {
            submit.disabled = false;
            msgBox.textContent = WP.L.ERR_NETWORK;
            msgBox.classList.add('is-error');
        });
});
